import React from 'react';

interface CardProps {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  className?: string;
}

export const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  children,
  className = '',
}) => {
  return (
    <div className={`bg-gray-900 border border-gray-800 rounded-xl p-6 shadow-xl text-gray-100 ${className}`}>
      {title && <h2 className="text-xl font-bold tracking-tight mb-1">{title}</h2>}
      {subtitle && <p className="text-sm text-gray-400 mb-4">{subtitle}</p>}
      {children}
    </div>
  );
};
